import { useEffect, useState } from 'react'
import { Input, InputGroup, InputGroupText } from 'reactstrap'

const PMBInputNumber = ({
  value = '',
  onChange,
  name,
  placeholder,
  isLastPrefix,
  isFirstPrefix,
  disabled = false,
  prefix = '',
  maxDecimalPlaces = 3,
  autoFocus = false,
  maxValue = null,
  testId = 'pmb-input-number',
  ...props
}) => {
  const [displayValue, setDisplayValue] = useState(value)

  useEffect(() => {
    setDisplayValue(value)
  }, [value])

  const handleChange = (e) => {
    const inputValue = e.target.value

    const validPattern = /^[\d.,]*$/
    if (!validPattern.test(inputValue)) return

    const commaCount = (inputValue.match(/,/g) || []).length
    if (commaCount > 1) return

    if (inputValue.includes(',')) {
      const decimalPart = inputValue.split(',')[1]
      if (decimalPart && decimalPart.length > maxDecimalPlaces) {
        return
      }
    }

    if (maxValue !== null) {
      const numericValue = Number(
        inputValue?.replace?.(/\./g, '')?.replace?.(/\,/g, '.'),
      )
      if (!isNaN(numericValue) && numericValue > maxValue) {
        // Build an event-like object to pass to onChange
        const formattedMax = maxValue.toString().replace('.', ',')
        setDisplayValue(formattedMax)
        onChange({ target: { name: e.target.name, value: formattedMax } })
        return
      }
    }

    setDisplayValue(inputValue)
    onChange(e)
  }

  return (
    <InputGroup>
      {isFirstPrefix && prefix && (
        <InputGroupText
          style={{
            backgroundColor: disabled ? '#E9ECEF' : 'transparent',
          }}
          className="text-sm"
        >
          {prefix}
        </InputGroupText>
      )}
      <Input
        type="text"
        value={displayValue}
        onChange={handleChange}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        data-testid={testId}
        {...props}
      />
      {isLastPrefix && prefix && (
        <InputGroupText
          style={{
            backgroundColor: disabled ? '#E9ECEF' : 'transparent',
          }}
          className="text-sm"
        >
          {prefix}
        </InputGroupText>
      )}
    </InputGroup>
  )
}

export default PMBInputNumber
